import { InputProps } from "./Input";

/* eslint-disable no-console */
export const getInputType = (type: string, showPassword: boolean) => {
  const isPasswordInput = type === 'password';
  if (!isPasswordInput) return type;
  return showPassword ? 'text' : 'password';
};

export const validateInputProps = ({
  id,
  onChange,
  changeCallback,
  error,
  sanitize
}: Partial<InputProps>) => {
  const warnPrefix = `Warning for form input ${id}:`;
  if (onChange && sanitize) {
    console.warn(`${warnPrefix} Looks like you are passing a sanitize function, but also overriding the default onChange function.
    Your sanitize function will not run.`);
  }
  if (error && !onChange) {
    console.warn(`${warnPrefix} Looks like you are passing an error, but not using a controlled Input. Error handing is not supported on the default Input.`);
  }
  if (onChange && changeCallback) {
    console.warn(`${warnPrefix} Input onChangeCallback does not fire if onChange prop is also included. Remove one for expected functionality.`);
  }
};
